/* src/components/Navbar.module.css */
.nav {
  position: fixed; top: 0; left: 0; right: 0; z-index: 1000;
  height: var(--nav-height);
  display: flex; align-items: center;
  transition: background 0.3s, box-shadow 0.3s;
}
.scrolled {
  background: rgba(6,10,15,0.96);
  backdrop-filter: blur(16px);
  box-shadow: 0 1px 0 var(--border);
}
.inner {
  max-width: 1200px; margin: 0 auto; width: 100%;
  padding: 0 5%;
  display: flex; align-items: center; justify-content: space-between;
}
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}
.logoImage {
  display: block;
  width: auto;
  max-width: 220px;
  height: auto;
}
.logoText {
  background: linear-gradient(135deg, var(--blue-light), var(--green));
  -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
}
.logoDot { color: var(--muted); font-size: 18px; }

.links {
  display: flex; align-items: center; gap: 2.5rem; list-style: none;
}
.link {
  font-family: 'Syne', sans-serif;
  font-size: 13px; font-weight: 600;
  letter-spacing: 0.8px; text-transform: uppercase;
  color: var(--muted); transition: color var(--transition);
  position: relative; padding-bottom: 3px;
  text-decoration: none;
}
.link::after {
  content: ''; position: absolute; bottom: -2px; left: 0; right: 0;
  height: 1px; background: var(--blue-light);
  transform: scaleX(0); transition: transform var(--transition);
}
.link:hover { color: var(--text); }
.link:hover::after { transform: scaleX(1); }
.active { color: var(--text) !important; }
.active::after { transform: scaleX(1) !important; }

.cta {
  font-family: 'Inter', sans-serif;
  font-size: 14px; font-weight: 700;
  letter-spacing: 0.35px; text-transform: uppercase;
  background: linear-gradient(135deg, var(--blue), var(--green-dark));
  color: #fff !important; padding: 12px 28px; border-radius: 999px;
  text-decoration: none;
  transition: transform var(--transition), box-shadow var(--transition), opacity var(--transition);
  display: inline-flex; align-items: center; justify-content: center;
  box-shadow: 0 16px 35px rgba(15,64,107,0.18);
}
.cta:hover { opacity: 0.95; transform: translateY(-1px); box-shadow: 0 20px 45px rgba(15,64,107,0.22); }

.hamburger {
  display: none; flex-direction: column; gap: 5px;
  background: none; border: none; cursor: pointer; padding: 4px;
}
.hamburger span {
  display: block; width: 24px; height: 2px;
  background: var(--text); border-radius: 2px;
  transition: var(--transition);
}
.open span:nth-child(1) { transform: rotate(45deg) translate(5px,5px); }
.open span:nth-child(2) { opacity: 0; }
.open span:nth-child(3) { transform: rotate(-45deg) translate(5px,-5px); }

.mobileMenu {
  position: fixed; inset: var(--nav-height) 0 0 0; z-index: 999;
  background: rgba(6,10,15,0.98); backdrop-filter: blur(20px);
  flex-direction: column; align-items: center; justify-content: center; gap: 2.5rem;
  pointer-events: none; opacity: 0;
  transform: translateY(-12px);
  transition: opacity 0.25s, transform 0.25s;
  display: flex;
}
.mobileOpen {
  pointer-events: all; opacity: 1; transform: translateY(0);
}
.mobileLink {
  font-family: 'Syne', sans-serif;
  font-size: 28px; font-weight: 700; color: var(--text);
  text-decoration: none;
  transition: color var(--transition);
}
.mobileLink:hover { color: var(--blue-light); }
.mobileCta {
  margin-top: 1rem;
  font-size: 16px !important;
  padding: 14px 32px !important;
}

@media (max-width: 900px) {
  .links { display: none; }
  .hamburger { display: flex; }
}

@media (max-width: 600px) {
  .logoImage { max-width: 140px; }
}
